// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FieldStringOutlinedSvg from "@fishx/icons-svg/es/asn/FieldStringOutlined";
import FishxIcon from '../components/FishxIcon';

var FieldStringOutlined = function FieldStringOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FieldStringOutlinedSvg
  }));
};

FieldStringOutlined.displayName = 'FieldStringOutlined';
export default React.forwardRef(FieldStringOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FieldStringOutlined.js
// module id = 2682
// module chunks = 0